import { toHex } from '@syllepsis/plugin-basic';
var StashStore = /** @class */ (function () {
    function StashStore(key, max) {
        this.data = [];
        this.maxSize = 0;
        this.key = '';
        this.maxSize = max;
        this.key = "syl-" + key;
        if (!localStorage)
            return;
        var stashData = localStorage.getItem(this.key);
        if (stashData) {
            try {
                this.data = JSON.parse(stashData);
            }
            catch (err) {
                this.data = [];
            }
        }
        else {
            this.data = [];
        }
    }
    StashStore.prototype.add = function (data, transformToHex) {
        if (transformToHex === void 0) { transformToHex = false; }
        if (!localStorage)
            return;
        var _data = transformToHex ? toHex(data) || '#000000' : data;
        var idx = this.data.findIndex(function (val) { return val === _data; });
        if (idx < 0) {
            this.data.unshift(_data);
            if (this.data.length > this.maxSize)
                this.data.pop();
        }
        else {
            this.data.splice(idx, 1);
            this.data.unshift(_data);
        }
        localStorage.setItem(this.key, JSON.stringify(this.data));
    };
    return StashStore;
}());
export { StashStore, toHex };
//# sourceMappingURL=utils.js.map